export default __webpack_public_path__ + "static/favicon-d603523ab3e3364b5870c4448a35d3e4.ico";